import React from "react";
import { useAuth } from "../../context/AuthContext";
import ClientDashboard from "./ClientDashboard";
import ManagementDashboard from "./ManagementDashboard";
import StaffDashboard from "./StaffDashboard";

export default function DashboardRouter() {
  const { user } = useAuth();
  if (["client_admin", "client_user"].includes(user.role)) return <ClientDashboard />;
  if (["platform_admin", "management"].includes(user.role)) return <ManagementDashboard />;
  return <StaffDashboard />;
}
